(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("UIRouterReact", ["react"], factory);
	else if(typeof exports === 'object')
		exports["UIRouterReact"] = factory(require("react"));
	else
		root["UIRouterReact"] = factory(root["React"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__672__) => {
return 